import styled from "@emotion/styled";
import { Panel } from "@xometry/xometry_loft";
import theme from "../../styles/theme";

export const UploadFilePanelContainer = styled.div`
  max-width: 600px;
  ${theme.largerThan.lg} {
    align-self: center;
  }
`;

export const LoadingPanelHome = styled(Panel)`
  border-radius: 5px;
  width: 100%;
  padding: 0px !important;
  height: 260px;
  background-color: white;
  border: none;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='5' ry='5' stroke='%238495A3FF' stroke-width='2' stroke-dasharray='4 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");

  ${theme.smallerThan.md} {
    height: 350px;
  }
`;

export const LoadingPanelInstantQuoteHero = styled(Panel)`
  border-radius: 5px;
  width: 100%;
  padding: 0px !important;
  height: 400px;
  background-color: transparent;
  border: none;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='5' ry='5' stroke='%238495A3FF' stroke-width='2' stroke-dasharray='4 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");

  ${theme.smallerThan.md} {
    height: 350px;
  }
`;
